import {View} from 'react-native';
import * as React from 'react';
import {useStyles} from '../../../../hooks/styles';
import {HolderAvatar} from '../../../holderAvatar';
import {useTheme} from '../../../../theme';
import {themeSelector} from '../../../../../redux/selectors/runtime/theme';
import {useSelector} from 'react-redux';
import {VisImpStatus} from '../../../../models/visuallyImpairedSettings';
import {images} from '../../../../../assets/icons';

const dataSetContainer = {
  dataSet: {
    class: 'profile-widget-container',
  },
};

export default () => {
  const theme = useTheme();
  const themeSettings = useSelector(themeSelector());
  const isVisImpActive = themeSettings.visuallyImpaired === VisImpStatus.Active;

  const styles = useStyles(() => ({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      overflow: 'hidden',
      paddingLeft: 12,
      paddingRight: 12,
      paddingBottom: 13,
      paddingTop: 13,
    },
  }));

  return (
    <View testID='avatar-img-test-id' {...dataSetContainer} style={styles.container}>
      {isVisImpActive ? (
        <images.ProfileVisImp color={theme.color.textColor} />
      ) : (
        <HolderAvatar preview size={24} color={theme.color.textColor} />
      )}
    </View>
  );
};
